import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axios from "axios";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  ShoppingBagIcon,
  ArchiveIcon,
  CheckIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  PhoneIcon,
  DotsVerticalIcon,
  LocationMarkerIcon,
  QuestionMarkCircleIcon,
  LinkIcon,
  PlusSmIcon,
  PaperClipIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import Leadmodalcreate from "./Leadmodalcreate";
import Leadmodaledit from "./Leadmodaledit";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Lead extends React.Component {
  constructor(props) {
    super(props);
    this.ChildElement = React.createRef();
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      redirect1: false,
      deleteRedirect: false,
      logoutRedirect: false,
      cryptKey: "",
      deletealartmsg: false,
      deletecustomer: false,
      loader: "animate-pulse",
      InvoiceStatusState: "",
      LeadStatusList: [],
      LeadNamefornoteView: "",
      leadNotemodalOpen: false,
      leadNoteList: [],
      lead_id: "",
      note: "",
      lead_status_id: "",
      lead_index_in_kanban_board: "",
      open: false,
      dialogLeadname: "",
      dialogEmail: "",
      dialogPosition: "",
      dialogPhone: "",
      dialogLeademployee: "",
      dialogLead_value: "",
      dialogCompany: "",
      dialogDescription: "",
      dialogAddress_street_one: "",
      dialogAddress_street_two: "",
      dialogWebsite: "",
      dialogAttention: "",
      dialogLeadsource: "",
      dialogLeadstatus: "",
      dialogleadCity: "",
      dialogcountry_region_id: "",
      dialogstate_id: "",
      dialogzipcode: "",
      leadCreate: false,
      logoutRedirect: false,
      success: false,
      error_list: [],
      employeeList: [],
      stateList: [],
      countryList: [],
      leadsourcesList: [],
      leadstatusList: [],
      lead_status_id: 0,
      lead_source_id: 0,
      employee_id: null,
      name: null,
      position: "",
      email_address: "",
      website: "",
      phone: "",
      lead_value: "",
      company: "",
      description: "",
      attention: "",
      country_region_id: "",
      address_street_one: "",
      address_street_two: "",
      city: "",
      state_id: "",
      zip_code: "",
      loader: "",
      overLay: "",
      moveMessage: "",
      product: "",
      vehicle: "",
      service_type: "",
      lead_date: "",
      service_type_id: null,
      serviceTypeList: [],
      leadEdit: false,
      editId:"",
      backtoLeadListredirect:"",
      leadCryptId:"",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");

    const res = axios
      .get("public/api/leads/kanban/board", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ LeadStatusList: res.data.lead_statuses_and_leads });
      });

    const res1 = axios
      .get("public/api/countries", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({ countryList: res1.data.countries });
      });

    const res3 = axios
      .get("public/api/lead/statuses", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ leadstatusList: res3.data.lead_statuses });
      });

    const res4 = axios
      .get("public/api/lead/sources", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({ leadsourcesList: res4.data.lead_source });
      });

    const res5 = axios
      .get("public/api/employees", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res5) => {
        this.setState({ employeeList: res5.data.employees });
        console.log(this.state.employeeList);
      });
    const res6 = axios
      .get("public/api/servicetypes", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res6) => {
        this.setState({ serviceTypeList: res6.data.service_type });
      });

    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        //this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    var token = localStorage.getItem("token");
    if (e.target.name === "country_region_id") {
      this.setLoaderFunction();

      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          //console.log(res.data.states);
          this.closeLoaderFuncion();

          this.setState({ stateList: res.data.states });
        });
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleInputModalleadCreate = (e) => {
    if (e) {
      this.setState({leadCreate:false});
      this.setState({redirect1:true});

    }
  }
  backtoList=(e)=>{
   
      this.setState({ backtoLeadListredirect: true });
  }

  handleInputModalleadEdit = (e) => {
      console.log(e);
      if (e) {
        this.setState({leadEdit:false});
        this.setState({redirect1:true});
      }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.redirect1 == true) {
      this.setState({ redirect1: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/leads/kanban/board", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ LeadStatusList: res.data.lead_statuses_and_leads });
        });
    }
  }

  saveItem = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/lead/store", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ moveMessage: "Successfully Saved" });

      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.setState({ showmsg: false });
          this.setState({ redirect1: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      this.setState({ leadCreate: false });
    } else {
      this.setState({ error_list: res.data.data });

      //this.setState({ redirect1: true });
    }
    this.closeLoaderFuncion();
  };

  updateLead = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    const { id } = this.state.leadEditcryptid;
    const res = await axios.post(
      "public/api/lead/update/" + this.state.leadEditcryptid,
      this.state,
      { headers }
    );
    if (res.data.success) {
      this.setState({ moveMessage: "Successfully Saved" });
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ showmsg: false });
          this.setState({ redirect1: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      this.setState({ leadEdit: false });
    } else {
      this.setState({ error_list: res.data.data });
    }
    this.closeLoaderFuncion();
  };

  onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    let statusAndIndexChangedLeadDataId;
    let leadDataCurrentStatusId;
    let leadIndexForCurrentStatus;

    if (source.droppableId !== destination.droppableId) {
      const sourceInvoiceStatusIndex = this.state.LeadStatusList.findIndex(
        (LeadStatusValue) => LeadStatusValue.id_in_string === source.droppableId
      );
      const destInvoiceStatusIndex = this.state.LeadStatusList.findIndex(
        (LeadStatusValue) =>
          LeadStatusValue.id_in_string === destination.droppableId
      );

      const sourceItems = [
        ...this.state.LeadStatusList[sourceInvoiceStatusIndex]["leads"],
      ];
      const destItems = [
        ...this.state.LeadStatusList[destInvoiceStatusIndex]["leads"],
      ];

      const [removed] = sourceItems.splice(source.index, 1);

      statusAndIndexChangedLeadDataId = removed["id_crypt"];
      leadDataCurrentStatusId = destination.droppableId;
      leadIndexForCurrentStatus = destination.index;

      destItems.splice(destination.index, 0, removed);

      this.state.LeadStatusList[sourceInvoiceStatusIndex]["leads"] =
        sourceItems;
      this.state.LeadStatusList[destInvoiceStatusIndex]["leads"] = destItems;

      this.setState({ LeadStatusList: this.state.LeadStatusList });
    } else {
      const sourceInvoiceStatusIndex = this.state.LeadStatusList.findIndex(
        (LeadStatusValue) => LeadStatusValue.id_in_string === source.droppableId
      );

      const copiedItems = [
        ...this.state.LeadStatusList[sourceInvoiceStatusIndex]["leads"],
      ];
      const [removed] = copiedItems.splice(source.index, 1);

      statusAndIndexChangedLeadDataId = removed["id_crypt"];
      leadDataCurrentStatusId = destination.droppableId;
      leadIndexForCurrentStatus = destination.index;

      copiedItems.splice(destination.index, 0, removed);

      this.state.LeadStatusList[sourceInvoiceStatusIndex]["leads"] =
        copiedItems;

      this.setState({ LeadStatusList: this.state.LeadStatusList });
    }

    this.networkCall(
      statusAndIndexChangedLeadDataId,
      leadDataCurrentStatusId,
      leadIndexForCurrentStatus
    );
  };
  openDialog = (e, LeadStatusIndex, LeadIndex) => {};

  networkCall = async (LeadId, leadStatusId, leadIndexForCurrentStatus) => {
    //console.log("networkCall");
    this.setLoaderFunction();

    this.state.lead_index_in_kanban_board = leadIndexForCurrentStatus;
    this.state.lead_status_id = leadStatusId;
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/leads/kanban/board/update/" + LeadId,
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.setState({ moveMessage: "Successfully Moved" });
      this.setState({ showmsg: true });

      this.setState({ LeadStatusList: res.data.lead_statuses_and_leads });
      setTimeout(
        function () {
          //Start the timer
          this.setState({ moveMessage: "" });
          this.setState({ showmsg: false });
          //this.setState({ loader: "" }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      this.closeLoaderFuncion();
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };
  fun = async (e) => {
    this.setState({
      open: false,
      dialogLeadname: "",
      dialogEmail: "",
      dialogPosition: "",
      dialogPhone: "",
      dialogLead_value: "",
      dialogCompany: "",
      dialogDescription: "",
      dialogAddress_street_one: "",
      dialogAddress_street_two: "",
      dialogWebsite: "",
      dialogAttention: "",
      dialogLeadsource: "",
      dialogLeadstatus: "",
      dialogleadCity: "",
      dialogLeademployee: "",
      dialogcountry_region_id: "",
      dialogstate_id: "",
      dialogzipcode: "",
      due_date:"",
    });
  };

  leadcreateClose = async (e) => {
    this.state.error_list = [];
    this.setState({ leadCreate: false });
  };

  leadupdateClose = async (e) => {
    //k console.log("as");
    this.state.error_list = [];
    this.setState({ leadEdit: false });
    this.setState({
      name: "",
      email_address: "",
      position: "",
      phone: "",
      lead_value: "",
      company: "",
      description: "",
      address_street_one: "",
      address_street_two: "",
      website: "",
      attention: "",
      lead_source_id: "",
      lead_status_id: "",
      city: "",
      employee_id: "",
      country_region_id: "",
      state_id: "",
      zip_code: "",
      product: "",
      vehicle: "",
      service_type: "",
      lead_date: "",
      service_type_id: "",
    });
  };

  addLead = async (e) => {
    this.setState({ leadCreate: true });
  };

  handleLeadNote = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  LeadNoteviewmodal = (id, e) => {
    const token = localStorage.getItem("token");
    this.state.LeadNoteId = id;
    this.state.lead_id = id;

    // this.setState({LeadNoteId:e});
    //const id=this.setState({cryptKey:e});
    const resView = axios
      .get("public/api/lead/edit/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((resView) => {
        if (resView.data.success) {
          this.setState({ leadNoteList: resView.data.lead.notes });
          this.setState({ LeadNamefornoteView: resView.data.lead.name });
          this.setState({ leadNotemodalOpen: true });

          // this.setState({LeadNoteId:''});
        } else {
        }
      });
  };
  leadNoteviewmodalclose = (e) => {
    this.setState({ leadNotemodalOpen: false });
    this.state.leadNoteList = [];
    this.state.LeadNamefornoteView = "";
  };

  addLeadnote = async (e) => {
    e.preventDefault();
    this.state.leadNoteList = [];
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/lead/note/store", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ leadNoteList: res.data.lead_notes });

      this.state.note = "";
    } else {
      this.setState({ error_list: res.data.data });
    }
  };

  view = async (id,e) => {
    this.state.lead_id = id;
   
    this.setState({leadCryptId:e});

    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/lead/edit/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({
          dialogLeadname: res.data.lead.name,
          dialogEmail: res.data.lead.email_address,
          dialogPosition: res.data.lead.position,
          dialogPhone: res.data.lead.phone,
          dialogLead_value: res.data.lead.lead_value,
          dialogLeademployee: res.data.lead.employee_id,
          dialogCompany: res.data.lead.company,
          dialogDescription: res.data.lead.description,
          dialogAddress_street_one: res.data.lead.address_street_one,
          dialogAddress_street_two: res.data.lead.address_street_two,
          dialogWebsite: res.data.lead.website,
          dialogAttention: res.data.lead.attention,
          dialogLeadsource: res.data.lead.lead_source_id,
          dialogLeadstatus: res.data.lead.lead_status_id,
          dialogleadCity: res.data.lead.city,

          dialogcountry_region_id: res.data.lead.country_region_id,
          dialogstate_id: res.data.lead.state_id,
          dialogzipcode: res.data.lead.zip_code,
          leadNoteList: res.data.lead.notes,
          product: res.data.lead.product,
          vehicle: res.data.lead.vehicle,
          service_type: res.data.lead.service_type,
          lead_date: res.data.lead.lead_date,
          service_type_id: res.data.lead.service_type_id,
          due_date: res.data.lead.due_date,
        });
      });
    setTimeout(
      function () {
        //Start the timer
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
    this.setState({ open: true });
  };

  edit = async (e) => {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");


    this.setState({ leadEditcryptid: e });
    const res = axios
      .get("public/api/lead/edit/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({
          name: res.data.lead.name,
          email_address: res.data.lead.email_address,
          position: res.data.lead.position,
          phone: res.data.lead.phone,
          lead_value: res.data.lead.lead_value,
          company: res.data.lead.company,
          description: res.data.lead.description,
          address_street_one: res.data.lead.address_street_one,
          address_street_two: res.data.lead.address_street_two,
          website: res.data.lead.website,
          attention: res.data.lead.attention,
          lead_source_id: res.data.lead.lead_source_id,
          lead_status_id: res.data.lead.lead_status_id,
          city: res.data.lead.city,
          employee_id: res.data.lead.employee_id,
          country_region_id: res.data.lead.country_region_id,
          state_id: res.data.lead.state_id,
          stateList: res.data.lead.states,
          zip_code: res.data.lead.zip_code,
          leadNoteList: res.data.lead.notes,
          product: res.data.lead.product,
          vehicle: res.data.lead.vehicle,
          service_type: res.data.lead.service_type,
          lead_date: res.data.lead.lead_date,
          service_type_id: res.data.lead.service_type_id,
        });
      });

    this.setState({ leadEdit: true });
    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
      }.bind(this),
      500
    );
  };

  updateLeadDuedata=async (e)=>{
    e.preventDefault();
    this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    
    const res = await axios.post(
      "public/api/lead/due/date/update/" + this.state.leadCryptId,
      this.state,
      { headers }
    );
    if (res.data.success) {
      this.setState({ moveMessage: "Successfully Saved" });
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ showmsg: false });
          this.setState({ redirect1: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      
      this.setState({ open: false });
    } else {
      this.setState({ error_list: res.data.data });
    }
    this.closeLoaderFuncion();
  }

  handleInputLeaddue_date=(e)=>{
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.backtoLeadListredirect) {
      this.state.backtoLeadListredirect=false;
      this.setState({backtoLeadListredirect:this.state.backtoLeadListredirect});
    return <Navigate to={"/filterby/LeadList"} />;
    }
    
    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          {/* Replace with your max-w-8xl changed from 7 content */}
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">Leads</h1>
                <p className="mt-2 text-sm text-gray-700">
                  A list of all the Leads
                </p>
              </div>
              <span className="hidden sm:block ml-3">
                        <button
                          onClick={this.backtoList}
                          type="button"
                          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          <LinkIcon
                            className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                            aria-hidden="true"
                          />
                          Back to List
                        </button>
                </span>
              <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
             
                <button
                  onClick={this.addLead}
                  type="button"
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                >
                  New Lead
                </button>
              </div>
            </div>

            <div className="mt-8 flex flex-col">
              <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                  <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                    {/**/}
                    <div className="py-4">
                      <div className="flex flex-row flex-nowrap">
                        <DragDropContext
                          onDragEnd={(result) => this.onDragEnd(result)}
                        >
                          {this.state.LeadStatusList.map(
                            (LeadStatusValue, LeadStatusIndex) => {
                              return (
                                <div
                                  className="shadow-2xl "
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                  }}
                                  key={LeadStatusValue.id_in_string}
                                >
                                  {" "}
                                  <span>
                                    <h2>{LeadStatusValue.name}</h2>
                                    <span className="text-right">
                                      <p className="text-xs text-center">
                                        Total Value:
                                        {
                                          LeadStatusValue.lead_status_amount
                                            ?.total_lead_value
                                        }
                                      </p>
                                    </span>
                                  </span>
                                  <div
                                    style={{ margin: 8 }}
                                    className="shadow-2xl  rounded-md "
                                  >
                                    <Droppable
                                      droppableId={LeadStatusValue.id_in_string}
                                      key={LeadStatusValue.id_in_string}
                                    >
                                      {(provided, snapshot) => {
                                        return (
                                          <div
                                            className={
                                              snapshot.isDraggingOver
                                                ? "bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 resize-x"
                                                : "bg-gradient-to-r from-cyan-500 to-blue-500 resize-x"
                                            }
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            style={{
                                              padding: 4,
                                              width: 250,
                                              minHeight: 500,
                                            }}
                                          >
                                            {LeadStatusValue.leads.map(
                                              (LeadValue, LeadIndex) => {
                                                return (
                                                  <Draggable
                                                    key={LeadValue.id_in_string}
                                                    draggableId={
                                                      LeadValue.id_in_string
                                                    }
                                                    index={LeadIndex}
                                                  >
                                                    {(provided, snapshot) => {
                                                      return (
                                                        <ul
                                                          role="list"
                                                          className="divide-y divide-gray-200 "
                                                        >
                                                          <div
                                                            className="bg-white shadow overflow-hidden sm:rounded-md "
                                                            onClick={(e) =>
                                                              this.openDialog(
                                                                e,
                                                                LeadStatusIndex,
                                                                LeadIndex
                                                              )
                                                            }
                                                            ref={
                                                              provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                              userSelect:
                                                                "none",
                                                              padding: 14,
                                                              margin:
                                                                "0 0 8px 0",
                                                              minHeight: "40px",

                                                              ...provided
                                                                .draggableProps
                                                                .style,
                                                            }}
                                                          >
                                                            <div class="flex justify-between ...">
                                                              <div class="order-last">
                                                                <span
                                                                  className={
                                                                    LeadValue.lead_already_customer
                                                                      ? "text-sm inline-flex items-center rounded bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800"
                                                                      : "text-sm inline-flex items-center rounded bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800"
                                                                  }
                                                                >
                                                                  {LeadValue.lead_already_customer
                                                                    ? "Yes"
                                                                    : "No"}
                                                                </span>
                                                              </div>
                                                              <div>
                                                                <p className="text-sm antialiased text-emerald-500	">
                                                                  <span class="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 to-violet-500">
                                                                    LeadName:{" "}
                                                                    {
                                                                      LeadValue.name
                                                                    }
                                                                  </span>
                                                                </p>
                                                              </div>
                                                            </div>

                                                            <p className="text-sm">
                                                              {" "}
                                                              Email:{" "}
                                                              {
                                                                LeadValue.email_address
                                                              }
                                                            </p>
                                                            <p className="text-sm">
                                                              Phone:{" "}
                                                              {LeadValue.phone}
                                                            </p>
                                                            <p className="text-sm">
                                                              Lead Value:{" "}
                                                              {
                                                                LeadValue.lead_value
                                                              }
                                                            </p>
                                                            <p className="text-sm">
                                                              <span className="text-align:left">
                                                                Product:{" "}
                                                                {
                                                                  LeadValue.product
                                                                }
                                                              </span>
                                                            </p>
                                                            <p className="text-sm">
                                                              <span className="text-align:left">
                                                                Vehicle:{" "}
                                                                {
                                                                  LeadValue.vehicle
                                                                }
                                                              </span>
                                                            </p>
                                                            <p className="text-sm">
                                                              <span className="text-align:left">
                                                                Service Type:{" "}
                                                                {
                                                                  LeadValue.lead_service_type?.name
                                                                }
                                                              </span>
                                                            </p>
                                                            <p className="text-sm">
                                                              <span className={`text-align:left`}>
                                                                Due Date:{" "}
                                                                { 
                                                                  LeadValue.due_date
                                                                }
                                                              </span>
                                                            </p>

                                                            <span
                                                              className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                                                              onClick={() =>
                                                                this.view(
                                                                  LeadValue.id,
                                                                  LeadValue.id_crypt
                                                                )
                                                              }
                                                            >
                                                              View
                                                            </span>
                                                            <span
                                                              className="inline-flex ml-2 items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                                                              onClick={() =>
                                                                this.LeadNoteviewmodal(
                                                                  LeadValue.id,
                                                                  LeadValue.id_crypt
                                                                )
                                                              }
                                                            >
                                                              View Note
                                                            </span>
                                                            <span
                                                              className="inline-flex ml-2 items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                                                              onClick={() =>
                                                                this.edit(
                                                                  LeadValue.id_crypt
                                                                )
                                                              }
                                                            >
                                                              Edit
                                                            </span>
                                                          </div>
                                                        </ul>
                                                      );
                                                    }}
                                                  </Draggable>
                                                );
                                              }
                                            )}
                                            {provided.placeholder}
                                          </div>
                                        );
                                      }}
                                    </Droppable>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </DragDropContext>
                      </div>
                    </div>

                    {/* */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Lead Info*/}
          <Transition.Root show={this.state.open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={this.fun}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                      <div>
                        <div className="mt-3  sm:mt-5">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          ></Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                                <div className="sm:px-6">
                                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                                    Lead Information
                                  </h3>
                                  <p className="mt-1 max-w-2xl text-sm text-gray-500"></p>
                                </div>
                                <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                                  <dl className="grid grid-cols-1  sm:grid-cols-3">
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Lead name
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogLeadname}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Date
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.lead_date}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Position{" "}
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogPosition}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Email{" "}
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogEmail}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Lead Status
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogLeadstatus}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Lead Source
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogLeadsource}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Employee
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogLeademployee}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        phone
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogPhone}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Lead Value
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogLead_value}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Company
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogCompany}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Product
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.product}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Vehicle
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.vehicle}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Service Type
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.service_type}
                                      </dd>
                                    </div>

                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Website
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogWebsite}
                                      </dd>
                                    </div>

                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Address
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogAttention}
                                        {this.state.dialogAddress_street_one},
                                        {this.state.dialogAddress_street_two}
                                        <br />
                                        {this.state.dialogleadCity},{" "}
                                        {this.state.dialogstate_id},{" "}
                                        {this.state.dialogzipcode}
                                      </dd>
                                    </div>
                                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                      <dt className="text-sm font-medium text-gray-500">
                                        Description
                                      </dt>
                                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        : {this.state.dialogDescription}
                                      </dd>
                                    </div>
                                  </dl>
                                  
                                </div>
                                
                              </div>
                            </p>
                                  <div className="px-4 py-5 sm:px-6">
                                      <h2
                                        id="notes-title"
                                        className="text-lg font-medium text-gray-900"
                                      >
                                        Due Date Update{" "}
                                        {this.state.LeadNamefornoteView}
                                      </h2>
                                    </div>
                                  <div class="grid grid-cols-2 gap-4 px-5">
                                  
                                          <form onSubmit={this.updateLeadDuedata}>
                                          <div className="">
                                            <label
                                              htmlFor="due_date"
                                              className="block text-sm font-medium text-gray-700"
                                            >
                                              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                                Due Date
                                              </span>
                                            </label>
                                            <input
                                              type="Date"
                                              name="due_date"
                                              id="due_date"
                                              value={this.state.due_date}
                                              onChange={this.handleInputLeaddue_date}
                                              autoComplete="due_date"
                                              className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                            />
                                            <p
                                              className="mt-2 text-sm text-red-600"
                                              id="due_date-error"
                                            >
                                              {this.state.error_list.due_date}
                                            </p>
                                          </div>
                                          <div className="mt-5 mb-2">
                                          <button
                                              type="submit"
                                              className=" inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            >
                                              Save
                                            </button>
                                            </div>
                                            </form> 
                                
                                </div>
                            {/** */}
                            <div class="grid grid-cols-1 gap-4">
                                <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                                  <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                                    <section aria-labelledby="notes-title">
                                      <div className="bg-white shadow sm:rounded-lg sm:overflow-hidden">
                                        <div className="divide-y divide-gray-200">
                                          <div className="px-4 py-5 sm:px-6">
                                            <h2
                                              id="notes-title"
                                              className="text-lg font-medium text-gray-900"
                                            >
                                              Activity{" "}
                                              {this.state.LeadNamefornoteView}
                                            </h2>
                                          </div>
                                          <div className="px-4 py-6 sm:px-6">
                                            <ul role="list" className="space-y-8">
                                              {this.state.leadNoteList.map(
                                                (comment) => (
                                                  <li key={comment.id}>
                                                    <div className="flex space-x-3">
                                                      <div className="flex-shrink-0">
                                                        <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                                          <svg
                                                            className="h-full w-full text-gray-300"
                                                            fill="currentColor"
                                                            viewBox="0 0 24 24"
                                                          >
                                                            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                          </svg>
                                                        </span>
                                                      </div>
                                                      <div>
                                                        <div className="text-sm">
                                                          <a
                                                            href="#"
                                                            className="font-medium text-gray-900"
                                                          ></a>
                                                        </div>
                                                        <div className="mt-1 text-sm text-gray-700">
                                                          <p>{comment.note}</p>
                                                        </div>
                                                        <div className="mt-2 text-xs	 space-x-2">
                                                          <span className="text-gray-400 font-small">
                                                            {comment.created_at}
                                                          </span>{" "}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-6 sm:px-6">
                                          <div className="flex space-x-3">
                                            <div className="flex-shrink-0">
                                              <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                                <svg
                                                  className="h-full w-full text-gray-300"
                                                  fill="currentColor"
                                                  viewBox="0 0 24 24"
                                                >
                                                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                              </span>
                                            </div>
                                            <div className="min-w-0 flex-1">
                                              <form
                                                action="#"
                                                onSubmit={this.addLeadnote}
                                              >
                                                <div>
                                                  <label
                                                    htmlFor="note"
                                                    className="sr-only"
                                                  >
                                                    Note
                                                  </label>
                                                  <textarea
                                                    id="note"
                                                    name="note"
                                                    rows={2}
                                                    value={this.state.note}
                                                    onChange={this.handleLeadNote}
                                                    className="shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                                                    placeholder="Add a note"
                                                    defaultValue={""}
                                                  />
                                                </div>
                                                <div className="mt-3 flex items-center justify-between">
                                                  <button
                                                    type="submit"
                                                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                                  >
                                                    Add
                                                  </button>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                               
                            
                            
                            </div>
                            {/** */}
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <button
                          type="button"
                          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                          onClick={this.fun}
                        >
                          Cancel
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
          {/*End Lead info/}
    
        {/* /End replace */}
        </div>

        {/*Modal Create*/}
        <Transition.Root show={this.state.leadCreate} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={() => this.leadcreateClose()}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                  <div>                  
                      <Leadmodalcreate
                        handleInputlead={this.handleInputModalleadCreate}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/*Modal Edit*/}
        <Transition.Root show={this.state.leadEdit} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={() => this.leadupdateClose()}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                  <div>                  
                      <Leadmodaledit
                        leadId={this.state.leadEditcryptid}
                        handleInputlead={this.handleInputModalleadEdit}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/*Lead Note view */}
        <Transition.Root show={this.state.leadNotemodalOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.leadNoteviewmodalclose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all lg:my-8 lg:max-w-lg lg:w-full lg:p-6">
                    <div>
                      <div className="mt-3  sm:mt-5">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        ></Dialog.Title>
                        <div className="mt-2">
                          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                              <section aria-labelledby="notes-title">
                                <div className="bg-white shadow sm:rounded-lg sm:overflow-hidden">
                                  <div className="divide-y divide-gray-200">
                                    <div className="px-4 py-5 sm:px-6">
                                      <h2
                                        id="notes-title"
                                        className="text-lg font-medium text-gray-900"
                                      >
                                        Lead Notes-{" "}
                                        {this.state.LeadNamefornoteView}
                                      </h2>
                                    </div>
                                    <div className="px-4 py-6 sm:px-6">
                                      <ul role="list" className="space-y-8">
                                        {this.state.leadNoteList.map(
                                          (comment) => (
                                            <li key={comment.id}>
                                              <div className="flex space-x-3">
                                                <div className="flex-shrink-0">
                                                  <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                                    <svg
                                                      className="h-full w-full text-gray-300"
                                                      fill="currentColor"
                                                      viewBox="0 0 24 24"
                                                    >
                                                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                    </svg>
                                                  </span>
                                                </div>
                                                <div>
                                                  <div className="text-sm">
                                                    <a
                                                      href="#"
                                                      className="font-medium text-gray-900"
                                                    ></a>
                                                  </div>
                                                  <div className="mt-1 text-sm text-gray-700">
                                                    <p>{comment.note}</p>
                                                  </div>
                                                  <div className="mt-2 text-xs	 space-x-2">
                                                    <span className="text-gray-400 font-small">
                                                      {comment.created_at}
                                                    </span>{" "}
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="bg-gray-50 px-4 py-6 sm:px-6">
                                    <div className="flex space-x-3">
                                      <div className="flex-shrink-0">
                                        <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                          <svg
                                            className="h-full w-full text-gray-300"
                                            fill="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                          </svg>
                                        </span>
                                      </div>
                                      <div className="min-w-0 flex-1">
                                        <form
                                          action="#"
                                          onSubmit={this.addLeadnote}
                                        >
                                          <div>
                                            <label
                                              htmlFor="note"
                                              className="sr-only"
                                            >
                                              Note
                                            </label>
                                            <textarea
                                              id="note"
                                              name="note"
                                              rows={2}
                                              value={this.state.note}
                                              onChange={this.handleLeadNote}
                                              className="shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                                              placeholder="Add a note"
                                              defaultValue={""}
                                            />
                                          </div>
                                          <div className="mt-3 flex items-center justify-between">
                                            <button
                                              type="submit"
                                              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                            >
                                              Add
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={this.leadNoteviewmodalclose}
                      >
                        Cancel
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*Lead Note view */}

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.moveMessage}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default Lead;
